/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n';
import { Component, Fragment } from '@wordpress/element';
import { InspectorControls } from '@wordpress/block-editor';
import { PanelBody, ToggleControl } from '@wordpress/components';

/**
 * Inner dependencies.
 */
import ColorOptions from '../../extensions/controls/color-options';
import PaddingControl from '../../extensions/controls/padding-control';
import MarginControl from '../../extensions/controls/margin-control';
import { generateCustomStyleCode } from '../../extensions/custom-styles';

/**
 * Inspector controls
 */
class Inspector extends Component {
	constructor( props ) {
		super( props );
		this.updateStyles = this.updateStyles.bind( this );
	}

	updateStyles( styles ) {
		const { setAttributes, clientId } = this.props;

		setAttributes( { blockClientId: clientId } );
		generateCustomStyleCode( styles, { ...this.props }, true );
		setAttributes( { blockAdvanceOptions: { ...styles } } );
	}

	render() {
		const { attributes, setAttributes } = this.props;
		const { stretchContainer } = attributes;

		return (
			<Fragment>
				<InspectorControls>
					<PanelBody
						/* translators: block settings */
						title={ __( 'Layout options' ) }
					>
						<ToggleControl
							label={ __( 'Strech container' ) }
							help={ __( 'Strech container to the size of window. Ignoring container size.' ) }
							checked={ stretchContainer }
							onChange={ () => {
								setAttributes( {
									stretchContainer: ! stretchContainer,
								} );
							} }
						/>
					</PanelBody>
					<ColorOptions { ...this.props } enableTextColor={ false } />
					<PanelBody
						/* translators: block settings */
						title={ __( 'Advance options' ) }
						initialOpen={ false }
					>
						<PaddingControl
							{ ...this.props }
							parentKey="blockAdvanceOptions"
							label={ __( 'Padding' ) }
							property="padding"
						/>
						<hr />
						<MarginControl
							{ ...this.props }
							parentKey="blockAdvanceOptions"
							label={ __( 'Margin' ) }
						/>
					</PanelBody>
				</InspectorControls>
			</Fragment>
		);
	}
}

export default Inspector;
